import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { CustomScrollbar } from './CustomScrollbar';

export function Layout() {
  return (
    <>
      <a href="#main-content" className="skip-link">
        İçeriğe atla
      </a>
      <Header />
      <div className="main-scroll" role="region" aria-label="Sayfa içeriği">
        <main id="main-content" tabIndex={-1}>
          <Outlet />
        </main>
        <Footer />
      </div>
      <CustomScrollbar />
    </>
  );
}
